import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { SUBMISSION_DEADLINE } from "@/lib/media";

function diff(target) {
  const ms = Math.max(0, target.getTime() - Date.now());
  const days = Math.floor(ms / (1000 * 60 * 60 * 24));
  const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  const seconds = Math.floor((ms / 1000) % 60);
  return { ms, days, hours, minutes, seconds };
}

function Cell({ value, label }) {
  return (
    <div className="flex flex-col items-center px-3 sm:px-4">
      <span className="text-3xl sm:text-4xl font-black text-white leading-none tabular-nums">
        {String(value).padStart(2, "0")}
      </span>
      <span className="text-[10px] sm:text-[11px] font-extrabold tracking-widest uppercase text-white/70 mt-1">
        {label}
      </span>
    </div>
  );
}

export default function Countdown({ testid = "countdown" }) {
  const [t, setT] = useState(() => diff(SUBMISSION_DEADLINE));

  useEffect(() => {
    const id = setInterval(() => setT(diff(SUBMISSION_DEADLINE)), 1000);
    return () => clearInterval(id);
  }, []);

  if (t.ms <= 0) {
    return (
      <div className="inline-flex items-center gap-2 bg-sprouts-slate text-white px-5 py-3 rounded-2xl shadow-card" data-testid={testid}>
        <Clock size={16} className="text-sprouts-yellow" />
        <span className="text-sm font-extrabold tracking-wide">School registrations are now closed</span>
      </div>
    );
  }

  return (
    <div
      className="inline-flex items-center bg-sprouts-slate text-white px-3 sm:px-5 py-3 sm:py-3.5 rounded-2xl shadow-card"
      data-testid={testid}
    >
      <div className="hidden sm:flex items-center gap-2 pr-4 mr-3 border-r border-white/10">
        <Clock size={16} className="text-sprouts-yellow" />
        <span className="text-[11px] font-extrabold tracking-widest uppercase text-white/70">
          School registrations
          <br />
          close 31 Jul 2026
        </span>
      </div>
      <Cell value={t.days} label="Days" />
      <span className="text-2xl sm:text-3xl font-black text-white/30 -mt-3">:</span>
      <Cell value={t.hours} label="Hrs" />
      <span className="text-2xl sm:text-3xl font-black text-white/30 -mt-3">:</span>
      <Cell value={t.minutes} label="Min" />
      <span className="text-2xl sm:text-3xl font-black text-white/30 -mt-3 hidden sm:inline">:</span>
      <div className="hidden sm:block">
        <Cell value={t.seconds} label="Sec" />
      </div>
    </div>
  );
}
